export enum ErrorType {
  API = 'api',
  PAGE = 'page',
}

export enum LiveChatEvent {
  OPENED = 'live_chat_opened',
  ENGAGED = 'live_chat_engaged',
  CLOSED = 'live_chat_closed',
}

export enum CallType {
  GENERAL = 'care - faults: general',
  PRIORITY = 'care - faults: priority',
}
